module.exports = __webpack_public_path__ + "static/img/IN.6a367aa2.svg";